import { Page, PageFC } from '../../../../types';

import catMinerTitleScreen from '../../../../media/cat-miner/cat-miner-logo-transparent.webp';
import blastingLoop from '../../../../media/cat-miner/blasting-loop.mp4';
import blastingLoopThumbnail from '../../../../media/cat-miner/blasting-loop-thumbnail.webp';
import miningLoop from '../../../../media/cat-miner/mining-loop.mp4';
import miningLoopThumbnail from '../../../../media/cat-miner/mining-loop-thumbnail.webp';
import environments from '../../../../media/cat-miner/environments.webp';
import moonrise from '../../../../media/cat-miner/moonrise.webp';
import desertTwilight from '../../../../media/cat-miner/desert-twilight.webp';
import rainbowMountains from '../../../../media/cat-miner/rainbow-mountains.webp';
import night from '../../../../media/cat-miner/night.webp';
import mining1 from '../../../../media/cat-miner/mining-1.webp';
import mining2 from '../../../../media/cat-miner/mining-2.webp';
import mining3 from '../../../../media/cat-miner/mining-3.webp';
import teleportation from '../../../../media/cat-miner/teleportation.mp4';
import teleportationThumbnail from '../../../../media/cat-miner/teleportation-thumbnail.webp';
import Carousel from '../../../carousel/Carousel';
import SmartVideo from '../../../smart-video/SmartVideo';

import DiscordBtn from '../../../pageElements/DiscordBtn';
import { lazy, Suspense } from 'react';

const CAT_MINER_STRING = 'cat-miner';

const links = (
  <>
    <div className="buttonContainer fade-in animation-delay-m">
      <a
        className="swim-in-bottom animation-delay-m"
        href="https://testflight.apple.com/join/kScThNV1"
        target="_blank"
        rel="noreferrer"
      >
        <button>iPhone download</button>
      </a>
      <a
        className="swim-in-bottom animation-delay-m"
        href="https://play.google.com/store/apps/details?id=com.biiirdgames.CatMiner"
        target="_blank"
        rel="noreferrer"
      >
        <button>Android Download</button>
      </a>
    </div>
  </>
);

const YoutubeWrapper = lazy(() => import('../../../embeds/YoutubeWrapper'));

const CatMiner: PageFC = ({ footer }) => {
  return (
    <div
      className={`game-page ${CAT_MINER_STRING} fade-in animation-delay-xxs`}
    >
      <section>
        <div>
          <img className="logo" src={catMinerTitleScreen} alt="Game Logo" />
          <p className="fade-in animation-delay-s">
            Cat Miner is in Open Beta now!
            <br />
            Join the testing below
          </p>
          {links}
        </div>
      </section>

      <section>
        <div>
          <Suspense
            fallback={
              <img
                src="https://i.ytimg.com/vi/1dE3uaBuMds/maxresdefault.jpg"
                alt="Screenshot showcasing game environments"
              />
            }
          >
            <YoutubeWrapper videoId="1dE3uaBuMds" />
          </Suspense>
        </div>
      </section>

      <section>
        <div>
          <p>
            <strong>Cat Miner</strong> is a simulation adventure where you
            choose your play style to get through dirt and rock, unearthing
            increasingly more valuable ores and gems and finding new adventures.
          </p>
          <SmartVideo
            src={miningLoop}
            altSrc={miningLoopThumbnail}
            alt="Thumbnail for video depicting mining in-game"
          />
        </div>
      </section>

      <section>
        <div>
          <p>
            Claw your problems away! Or if you're more into explosions, blow 'em
            sky high!
          </p>
          <SmartVideo
            src={blastingLoop}
            altSrc={blastingLoopThumbnail}
            alt="Thumbnail for video depicting blasting in-game"
          />
        </div>
      </section>

      <section>
        <div>
          <p>
            Discover new horizons as you keep moving through progressively
            deeper and more colorful mining locations.
          </p>
          <Carousel>
            <img
              src={environments}
              alt="Screenshot showcasing multiple game environments"
            />
            <img src={moonrise} alt="Screenshot showcasing game environments" />
            <img
              src={desertTwilight}
              alt="Screenshot showcasing game environments"
            />
            <img
              src={rainbowMountains}
              alt="Screenshot showcasing game environments"
            />
            <img src={night} alt="Screenshot showcasing game environments" />
          </Carousel>
        </div>
      </section>

      <section>
        <div>
          <p>Build your own mining operation...</p>
          <Carousel>
            <img src={mining1} alt="Screenshot showcasing mining operations" />
            <img src={mining2} alt="Screenshot showcasing mining operations" />
            <img src={mining3} alt="Screenshot showcasing mining operations" />
          </Carousel>
        </div>
      </section>

      <section>
        <div>
          <p>
            ...and use <s>magic</s> <em>teleporter science</em> to get around!
          </p>
          <SmartVideo
            src={teleportation}
            altSrc={teleportationThumbnail}
            alt="Thumbnail for video depicting teleportation in-game"
          />
        </div>
      </section>

      <section>
        <div>
          <p>
            Ready to jump into the action? Join the <strong>Cat Miner</strong>{' '}
            Open Beta now!
          </p>
          {links}
          <p>
            Come join the biiird games Discord server and let's have a chat!
          </p>
          <DiscordBtn />{' '}
        </div>
      </section>

      <section id="privacy">
        <div>
          <a href="/cat-miner-eula.pdf" target="_blank">
            <p>End User License Agreement</p>
          </a>
          <a href="/cat-miner-privacy">
            <p>Privacy Policy</p>
          </a>{' '}
        </div>
        <div className="bottom">{footer ?? null}</div>
      </section>
    </div>
  );
};

const CatMinerPage: Page = {
  FC: CatMiner,
  frameClass: CAT_MINER_STRING,
  snapScroller: true,
  name: 'Cat Miner',
  url: CAT_MINER_STRING,
};

export default CatMinerPage;
export { CAT_MINER_STRING };
